import 'hammerjs'
import { enableProdMode, provideZoneChangeDetection } from '@angular/core'
import { platformBrowser } from '@angular/platform-browser'

import { AppModule } from './app/app.module.js'
import { environment } from './environments/environment.js'
import { setSignalImplementation } from '@lg/shared/for-studio'
import { signal, computed } from '@angular/core'

if (environment.production) {
	enableProdMode()
}

setSignalImplementation({
	signal,
	computed,
})

platformBrowser()
	.bootstrapModule(AppModule, {
		applicationProviders: [provideZoneChangeDetection()],
	})
	.catch((err) => console.error(err))
